import { render, staticRenderFns } from "./CommunityDetail.vue?vue&type=template&id=af64e34e&scoped=true"
import script from "./CommunityDetail.vue?vue&type=script&lang=js"
export * from "./CommunityDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityDetail.vue?vue&type=style&index=0&id=af64e34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af64e34e",
  null
  
)

export default component.exports